import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Close, SortDownArrow } from "../../assets/svg";
import Action from "../../components/common/Action";
import Breadcrumb from "../../components/common/BreadCrumb";
import DebounceSearch from "../../components/common/DebounceSearch";
import CustomTable from "../../components/customTable/CustomTable";
import RippleLoader from "../../components/loader/RippleLoader";
import {
  DefaultPrimaryButton,
  PrimaryButton,
} from "../../components/micro/input";
import ConfirmationModel from "../../components/common/ConfirmationModel";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import Toggles from "../../components/common/Toggles";
import {
  DeleteOutlet,
  companiesStaff,
  getOutlet,
  updateOutletsStatus,
} from "../../redux/companies/slice";

const Outlets = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const companyData = JSON.parse(sessionStorage.getItem("companyData") || "{}")
    ?.company?.id;
  const [searchValue, setSearchValue] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("active");
  const [showBreakdown, setShowBreakdown] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [outletFilter, setOutletFilter] = useState(null);
  const [managerFilter, setManagerPersonFilter] = useState(null);
  const [popupData, setPopupData] = useState({ id: null, status: "" });
  const [confirmArchive, setConfirmArchive] = useState(false);
  const [confirmUnarchive, setConfirmUnarchive] = useState(false);
  const [staffIdToArchive, setStaffIdToArchive] = useState(null);
  const [staffIdToUnarchive, setStaffIdToUnarchive] = useState(null);
  const [staffIdToDelete, setStaffIdToDelete] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);

  // selector
  const { outletList, staffList, loading } = useSelector((store) => ({
    outletList: store?.companiesData?.getOutletStatus?.data?.data,
    staffList: store?.companiesData?.companiesStaffStatus?.data?.data,
    loading: store?.companiesData?.loading,
  }));

  useEffect(() => {
    dispatch(
      getOutlet({
        search: searchValue,
        pageCount: pageCount,
        pageLimit: pageLimit,
        status: activeTab === "archived" ? "archive" : activeTab,
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
        company_id: "",
        outlet: outletFilter?.value || "",
        manager: managerFilter?.value || "",
      })
    );
    dispatch(
      companiesStaff({
        search: searchValue,
        roles: "manager",
        pageCount: pageCount,
        pageLimit: pageLimit,
        types: "Outlet",
        outlet: "",
        company_id: companyData?.id || "",
        sort_by: "",
        sort_direction: "",
      })
    );
  }, [
    searchValue,
    pageCount,
    pageLimit,
    activeTab,
    sortBy,
    sortDirection,
    outletFilter,
    managerFilter,
  ]);

  const handleSalesExportClick = () => {
    const headers = [
      "No.",
      "Outlet",
      "Address",
      "Manager",
      "Equipment",
      "Status",
    ];

    const rows = outletList?.data?.map((item, index) => [
      index + 1,
      item?.name,
      item?.address,
      item?.manager_name,
      item?.outlet_equipment?.length,
      item?.status,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((e) => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "product_interest.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const ColumnHeaders = () => (
    <>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        No.
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("name");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Outlet</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "name" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Address
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("manager_name");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Manager</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "manager_name"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("equipment_count");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Equipment</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "equipment_count"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      {activeTab === "active" && (
        <th
          scope="col"
          className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
        >
          <div className="flex items-center">
            <span>Status</span>
          </div>
        </th>
      )}
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Actions
      </th>
    </>
  );

  const managerOptions = [
    ...new Set(staffList?.data?.map((item) => item?.user)),
  ].map((person) => ({
    label: person?.full_name,
    value: person?.id,
  }));

  const handleToggle = (element) => {
    const newStatus = element.status === "active" ? "inactive" : "active";
    const isActive = newStatus === "active";

    updateStatus(element, newStatus, isActive);
  };

  const DataRows = () => (
    <>
      {(outletList?.data || [])?.map((item, index) => (
        <tr
          key={index}
          className="font-Proxima shadow-sm text-mgrey hover:bg-lightprimaryorange"
        >
          <td className="px-4 py-3">{index + 1}</td>
          <td className="px-4 py-3">{item?.name || "-"}</td>
          <td className="px-4 py-3">{item?.address || "-"}</td>
          <td className="px-4 py-3">{item?.manager_name || "-"}</td>
          <td
            className="px-4 py-3 text-themeBtn font-semibold cursor-pointer underline"
            onClick={() => {
              setSelectedRowId(item?.id);
              setShowBreakdown(true);
            }}
          >
            {item?.outlet_equipment?.length || "-"}
          </td>
          {activeTab === "active" && (
            <td className="px-5 py-3 truncate">
              <Toggles
                checked={item?.status === "active"}
                toggleFor={item?.id}
                onChange={() => handleToggle(item)}
              />
            </td>
          )}
          <td className="flex px-5 py-3">
            {activeTab === "active" ? (
              <Action
                optionList={
                  <>
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() =>
                        navigate("/view-outlet", {
                          state: { staff: item, mode: "edit" },
                        })
                      }
                    >
                      View/Edit
                    </li>
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() => {
                        setConfirmArchive(true);
                        setStaffIdToArchive(item?.id);
                      }}
                    >
                      Archive
                    </li>
                  </>
                }
              />
            ) : (
              <Action
                optionList={
                  <>
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() => {
                        setConfirmUnarchive(true);
                        setStaffIdToUnarchive(item?.id);
                      }}
                    >
                      Unarchive
                    </li>
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() => {
                        setConfirmDelete(true);
                        setStaffIdToDelete(item?.id);
                      }}
                    >
                      Delete
                    </li>
                  </>
                }
              />
            )}
          </td>
        </tr>
      ))}
    </>
  );

  const ItemsBreakdownModal = ({ show, onClose, selectedId }) => {
    if (!show) return null;

    const breakdownItems = outletList?.data?.filter(
      (item) => item.id === selectedId
    );

    return (
      <div className="backdrop-blur-sm bg-black/40 flex items-center justify-center w-full fixed top-0 left-0 right-0 z-[9999] mx-auto h-screen !my-0">
        <div
          className={`bg-white flex flex-col justify-center drop-shadow-lg rounded-lg w-full max-w-4xl py-8 px-6 mx-auto relative`}
        >
          <div className="flex justify-between mb-4">
            <h4 className="text-3xl font-Montserrat font-light">
              Equipment List
            </h4>
            <button onClick={onClose} className="font-light">
              <Close />
            </button>
          </div>
          <table className="w-full text-sm table-fixed">
            <thead className="text-sm text-primaryBlack bg-bgLightTheme font-normal text-start">
              <tr className="bg-gray-100 text-sm text-left">
                <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
                  No.
                </th>
                <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
                  Item
                </th>
                <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
                  Category
                </th>
                <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
                  Warranty
                </th>
              </tr>
            </thead>
            <tbody className="text-sm font-normal">
              {breakdownItems[0]?.outlet_equipment?.map((item, index) => (
                <tr
                  key={index}
                  className="font-Proxima shadow-sm text-mgrey hover:bg-lightprimaryorang"
                >
                  <td className="px-4 py-2">{index + 1}</td>
                  <td className="px-4 py-2">{item?.product_name || "-"}</td>
                  <td className="px-4 py-2">{item?.category_name || "-"}</td>
                  <td className="px-4 py-2">
                    {item?.warranty_expiry_date || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const updateStatus = (element, status, isActive) => {
    dispatch(
      updateOutletsStatus({
        id: element?.id,
        data: {
          status: status,
          is_active: isActive,
        },
      })
    ).then((res) => {
      if (res.type === "updateOutletsStatus/fulfilled") {
        dispatch(
          getOutlet({
            search: searchValue,
            pageCount: pageCount,
            pageLimit: pageLimit,
            status: activeTab === "archived" ? "archive" : activeTab,
            sort_by: sortBy,
            sort_direction: sortDirection === "asc" ? "asc" : "desc",
            company_id: "",
            outlet: outletFilter?.value || "",
            manager: managerFilter?.value || "",
          })
        );
      }
    });
  };

  const handleArchive = () => {
    const staffToArchive = outletList?.data?.find(
      (staff) => staff.id === staffIdToArchive
    );

    if (staffToArchive) {
      updateStatus(staffToArchive, "archive", false);
    }
    setConfirmArchive(false);
  };

  const handleUnarchive = () => {
    const staffToUnarchive = outletList?.data?.find(
      (staff) => staff.id === staffIdToUnarchive
    );

    if (staffToUnarchive) {
      updateStatus(staffToUnarchive, "active", true);
    }
    setConfirmUnarchive(false);
  };

  const handelSaleDelete = () => {
    setIsLoading(true);
    if (!staffIdToDelete) return;
    dispatch(DeleteOutlet(staffIdToDelete)).then((res) => {
      if (res.type === "DeleteOutlet/fulfilled") {
        dispatch(
          getOutlet({
            search: searchValue,
            pageCount: pageCount,
            pageLimit: pageLimit,
            status: activeTab === "archived" ? "archive" : activeTab,
            sort_by: sortBy,
            sort_direction: sortDirection === "asc" ? "asc" : "desc",
            company_id: "",
            outlet: outletFilter?.value || "",
            manager: managerFilter?.value || "",
          })
        );
      }
      setIsLoading(false);
      setConfirmDelete(false);
    });
  };

  return (
    <>
      <div className="space-y-7">
        <div className="flex justify-between items-start">
          <div>
            <h6 className="font-Montserrat font-medium text-xl mb-3">
              Outlets
            </h6>
            <Breadcrumb
              breadCrumbParent={"Home"}
              breadCrumbActive={"Outlets"}
              breadCrumbTitleKey={"/"}
              classes=""
            />
          </div>
          {activeTab === "active" && (
            <div>
              <PrimaryButton
                value=" + Add Outlets"
                onClick={() => navigate("/create-edit-outlet")}
              />
            </div>
          )}
        </div>
        <div>
          <h6 className="font-Montserrat font-normal text-2xl mb-3">
            My Outlets ({outletList?.data?.length})
          </h6>
        </div>
        <div className="flex mb-4 w-full">
          {["active", "archived"].map((el, index) => (
            <button
              key={el}
              className={`transition font-Proxima uppercase duration-300 text-sm font-normal px-4 py-1.5 w-full
        ${index === 0 ? "!rounded-l !rounded-r-none" : ""}
        ${index === 1 ? "!rounded-r !rounded-l-none" : ""}
        ${
          activeTab === el
            ? "border-themeBtn text-themeBtn border bg-disableThemeBtn"
            : "border-themeBtn text-themeBtn border"
        }`}
              onClick={() => setActiveTab(el)}
            >
              {el}
            </button>
          ))}
        </div>
        <div className="flex flex-wrap sm:flex-nowrap gap-3 items-center justify-between">
          <ReactSelect
            className="w-full sm:max-w-52 text-black p-0 font-Proxima"
            id="outlet"
            placeholder="Outlet"
            options={(Array.isArray(outletList?.data)
              ? outletList?.data
              : outletList?.data?.data || []
            ).map((outlet) => ({
              value: outlet.id,
              label: outlet.name,
            }))}
            isClearable={true}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            value={outletFilter}
            onChange={(selectedOption) => setOutletFilter(selectedOption)}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: outletFilter ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "&:active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />

          <ReactSelect
            className="w-full sm:max-w-52 text-black p-0 font-Proxima"
            id="manager"
            placeholder="Manager"
            options={managerOptions}
            isClearable={true}
            getOptionValue={(option) => option.value}
            getOptionLabel={(option) => option.label}
            value={managerFilter}
            onChange={(selectedOption) =>
              setManagerPersonFilter(selectedOption)
            }
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "&:active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />

          <DebounceSearch
            className="w-full sm:flex-1"
            search={searchValue}
            handleChange={setSearchValue}
            placeholder={"Search..."}
          />
          <DefaultPrimaryButton
            className={"w-full sm:w-auto"}
            value="EXPORT"
            onClick={handleSalesExportClick}
          />
        </div>
        {isLoading || loading ? (
          <RippleLoader />
        ) : (
          <div className="w-full bg-white shadow rounded-lg mt-5 overflow-x-auto">
            <div className="min-w-[600px]">
              <CustomTable
                columnHeaders={<ColumnHeaders />}
                dataRows={<DataRows />}
                data={outletList}
                overflowVisibleLg={true}
                // loader
                loading={false}
                showPagination={true}
                // showLimit
                setPaginationCurrentLimit={setPageLimit}
                paginationCurrentLimit={pageLimit}
                // paginationData
                total={outletList?.data?.length}
                current={pageCount}
                paginationData={(crPage) => setPageCount(crPage)}
                lastPage={Math.ceil(outletList?.data?.length / pageLimit)}
              />
            </div>
          </div>
        )}
      </div>
      {popupData.id && popupData.status && (
        <div>
          <ConfirmationModel
            confirmText={`Change Status to ${popupData.status}`}
            onConfirm={() => setPopupData(false)}
            onCancel={() => setPopupData(false)}
            isLoading={isLoading}
          />
        </div>
      )}
      <ItemsBreakdownModal
        show={showBreakdown}
        selectedId={selectedRowId}
        onClose={() => setShowBreakdown(false)}
      />
      {confirmArchive && (
        <div>
          <ConfirmationModel
            confirmText={"Archive"}
            onClose={() => {
              setConfirmArchive(false);
            }}
            onConfirm={handleArchive}
          />
        </div>
      )}

      {confirmUnarchive && (
        <div>
          <ConfirmationModel
            confirmText={"Unarchive"}
            onClose={() => {
              setConfirmUnarchive(false);
            }}
            onConfirm={handleUnarchive}
          />
        </div>
      )}
      {confirmDelete && (
        <div>
          <ConfirmationModel
            confirmText={"Delete"}
            onClose={() => {
              setConfirmDelete(false);
            }}
            onConfirm={handelSaleDelete}
            isLoading={isLoading}
          />
        </div>
      )}
    </>
  );
};

export default Outlets;
